import { USER_EXCHANGE_CODES } from "./const";
import { initUserExchange } from "./user-exchanges.inits";

/**
 * @param {UserExchangeBulk} form
 * @returns {UserExchangeBulk}
 */
export function initUserExchangeBulk(form) {
    form = {
        ...(form || {}),

        _id: form?._id,

        _member: form?._member,
        _giftee: form?._giftee,
        giftee: form?.giftee,

        _gift: form?._gift,
        gift: form?.gift,
        gifts: form?.gifts,

        exchanges: (form?.exchanges || []).map(initUserExchange),
        exchanges_toCash: (form?.exchanges_toCash || []).map(initUserExchange),
        exchanges_toGift: (form?.exchanges_toGift || []).map(initUserExchange),

        ip: form?.ip,
        code: form?.code || USER_EXCHANGE_CODES.AUCTION.value,
        type: form?.type,
        amount: form?.amount || 0,

        done: form?.done ?? false,
        fail: form?.fail ?? false,

        cashed: form?.cashed ?? false,
        gifted: form?.gifted ?? false,
        undone: form?.undone ?? false,

        failedToCash: form?.failedToCash ?? false,
        failedToGift: form?.failedToGift ?? false,

        errorMessage: form?.errorMessage || null,

        createdAt: form?.createdAt,
    };

    if (!form._id) delete form._id;
    if (!form._member) delete form._member;
    if (!form._giftee) delete form._giftee;
    if (!form.giftee) delete form.giftee;
    if (!form._gift) delete form._gift;
    if (!form.gift) delete form.gift;
    if (!form.ip) delete form.ip;
    if (!form.type) delete form.type;
    if (!form.createdAt) delete form.createdAt;

    return form;
}

/**
 * @typedef UserExchangeBulk
 *
 * @property {string} [_id]
 *
 * @property {string} [_member]
 *
 * @property {string} [_giftee]
 * @property {object} [giftee]
 *
 * @property {string} [_gift]
 * @property {import("./").UserExchangeGift} [gift]
 * @property {import("./").UserExchangeGift[]} [gifts]
 *
 * @property {string} [_cash]
 *
 * @property {import("./user-exchanges.inits").UserExchange[]} exchanges
 * @property {import("./user-exchanges.inits").UserExchange[]} [exchanges_toCash]
 * @property {import("./user-exchanges.inits").UserExchange[]} [exchanges_toGift]
 *
 * @property {string} [ip]
 * @property {string} [type]
 * @property {keyof USER_EXCHANGE_CODES} code
 * @property {number} amount
 *
 * @property {boolean} done
 * @property {boolean} fail
 *
 * @property {boolean} cashed
 * @property {boolean} gifted
 * @property {boolean} undone
 *
 * @property {boolean} failedToCash
 * @property {boolean} failedToGift
 *
 * @property {string|null} errorMessage
 *
 * @property {string} [createdAt]
 */
